export default __webpack_public_path__ + "static/media/0006.4c93194d.WAV";